export default __webpack_public_path__ + "static/media/walks_1280.310d8538.webp";